import { InjectionToken } from '@angular/core';
import { DEFAULT_ERROR_MESSAGES } from '../../components/legacy/form/form-field/form-field-error/error-message';

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => DEFAULT_ERROR_MESSAGES
});
